import { UseQueryOptions } from 'react-query'
import { useScheduledPost } from './useScheduledPost'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'

interface Props {
  id: number
}

interface Options extends Omit<UseQueryOptions<ScheduledPostShow, Error>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollScheduledPostStatus = ({ id }: Props, options?: Options) => {
  return useScheduledPost(
    { id },
    {
      refetchInterval: (data) => {
        if (!data?.is_posting) return false

        return options?.intervalMs || 2500
      },
      ...options,
    },
  )
}
